import { assignBudgetsStyles } from "@insite/content-library/Widgets/Budget/AssignBudgets";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

assignBudgetsStyles.filterGridItem = {
    width: 12,
    css: css`
        display: block;
        padding: 15px 15px 0 15px;
        > div[class^="sc"] {
            min-width: 25%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            display: block;
                        `,
                        null,
                        css`
                            min-width: 45%;
                        `,
                    ],
                    "minMax",
                )}
        }
    `,
};
assignBudgetsStyles.wrapper = {
    css: css`
        display: inline-block;
        margin-right: 30px;
        margin-bottom: 15px;
        min-width: 15%;
        ${({ theme }) => {
            return breakpointMediaQueries(theme, [
                css`
                    min-width: 50%;
                `,
                css`
                    min-width: 50%;
                `,
                css`
                    min-width: 25%;
                `,
                null,
                null,
            ]);
        }}
    `,
};

assignBudgetsStyles.dataTable = {
    css: css`
        tr {
            th {
                padding: 0 5px;
            }
        }
    `,
};

assignBudgetsStyles.filterGridItem = {
    width: 12,
    css: css`
        display: block;
        padding: 15px 15px 0 15px;
        > div {
            min-width: 15%;
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        min-width: 50%;
                    `,
                    css`
                        min-width: 50%;
                    `,
                    css`
                        min-width: 25%;
                    `,
                    null,
                    null,
                ]);
            }}
        }
    `,
};
assignBudgetsStyles.buttonsGridItem = {
    width: [12, 12, 4, 4, 4],
    css: css`
        justify-content: flex-end;
        padding: 15px;
        > button[class^="ButtonWrapper"] {
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            padding: 0 14px;
                        `,
                        null,
                    ],
                    "minMax",
                )}
        }
    `,
};
